const languages = ['EN','PL']

export default languages;